import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'

import auth, { LOGOUT } from './auth'
import albums from './albums'
import search from './search'
import query, { queryFormPlugin } from './query'
import entities from './entities'
import nav from './nav'
import modals from './modals'
import hierarchy from './hierarchy'
import users from './users'
import perms from './perms'
import share from './share'
import keywords from './keywords'
import playlists from './playlists'
import queues from './queues'
import dynlinks from './dynlinks'
import banners from './banners'
import libraries from './libraries'
import config from './config'

const reducer = combineReducers({
  auth,
  albums,
  search,
  query,
  entities,
  nav,
  modals,
  hierarchy,
  users,
  perms,
  share,
  keywords,
  playlists,
  queues,
  dynlinks,
  banners,
  libraries,
  config,
  routing: routerReducer,
  form: formReducer.plugin(queryFormPlugin)
})

export default function (state, action) {
  // Complete store reset on logout
  if (action.type === LOGOUT) {
    return reducer({
      // Keep some state to not mess up logging out
      routing: state.routing,
      form: state.form
    }, action)
  }
  return reducer(state, action)
}



// WEBPACK FOOTER //
// ./src/redux/reducer.js